import Modal from '@/components/modals/modal/modal.vue'

export default {
  name: 'ConfirmModal',
  props: {
    isAlert: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Modal
  },
  methods: {
    show () {
      this.$refs.modal.show()
    },
    hide () {
      this.$refs.modal.hide()
    },
    onApply () {
      this.$emit('apply')
      this.hide()
    }
  }
}